module.exports = __webpack_public_path__ + "img/firenze.75cb6cd2.jpg";